import HeroAbout from "@/components/common/HeroAbout";
import Container from "@/components/layout/Container";
import { clients as clientsData, ClientCategory } from "@/constants";

const AboutClients = () => {
  return (
    <Container>
      <HeroAbout />

      <div className=" mx-auto py-[30px] about:gap-10 px-[2rem] wide:px-0">
        {/* Client Sections */}
        {clientsData?.map((category: ClientCategory, catIdx) => (
          <section key={catIdx} className="mb-16">
            <h2 className="text-[2.8rem] font-bold mb-8 pb-6 border-b-2 border-black/60 text-left">
              {category.category}
            </h2>
            <div className="grid grid-cols-3 gap-4 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7">
              {category.list.map((client, idx) => (
                <div
                  key={idx}
                  className="flex items-center justify-center p-4 transition-shadow bg-white border rounded-sm border-gray-1"
                >
                  <img
                    src={`/img/about/${client.img}`}
                    alt={client.name}
                    className="max-w-full h-auto max-h-[58px] object-contain"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </Container>
  );
};

export default AboutClients;
